import { useQueries } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getLedgerWallets } from 'services/LedgerService'
import { LedgerWalletStatus } from 'types/ledger/ledgerWalletTransactions'

export const useGetLedgerWalletsByCurrencies = (
  currencies: string[],
  statuses?: LedgerWalletStatus[]
) => {
  return useQueries({
    queries: currencies.map(currency => ({
      queryKey: reactQueryKeys.ledgerWallets({ currencyCode: currency, statuses }),
      queryFn: () => getLedgerWallets({ currencyCode: currency, statuses }),
      enabled: currencies.length > 0,
    })),
  })
}
